import { ChainId } from 'vvs-sdk'
import { serializeTokens } from './tokens'
import { SerializedPoolConfig, PoolCategory } from './types'

const serializedTokens = serializeTokens()

const mainnetPools: SerializedPoolConfig[] = [
  {
    sousId: 0,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.vvs,
    contractAddress: {
      25: process.env.REACT_APP_CRAFTSMAN_ADDRESS_MAINNET,
      338: process.env.REACT_APP_CRAFTSMAN_ADDRESS_TESTNET,
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: (
      parseFloat(process.env.REACT_APP_VVS_PER_BLOCK) *
      (parseFloat(process.env.REACT_APP_CRAFTSMAN_POOL_ZERO_ALLOC_PT) /
        parseFloat(process.env.REACT_APP_CRAFTSMAN_TOTAL_ALLOC_PT))
    ).toString(),
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 22,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.croid,
    contractAddress: {
      25: '0x0DD343F2f0e934Cc9468832fD18B704bbC27b6C6',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.41232639',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 21,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.mtd,
    contractAddress: {
      25: '0xA35f370eF77a438791627C215cA40c463fa74dBA',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.080309876543000000',
    sortOrder: 1,
    isFinished: false,
    suffix: 'ep.2',
  },
  {
    sousId: 20,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.xargo,
    contractAddress: {
      25: '0xD44E985aeF629f8FC134092349a31e139E96149e',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '1.6620184758',
    sortOrder: 1,
    isFinished: false,
    suffix: 'ep.2',
  },
  {
    sousId: 19,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.mtd,
    contractAddress: {
      25: '0x35bf1a73033A64b7AE6e9844d66DBceE9e2D7aad',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.771606481481481481',
    sortOrder: 1,
    isFinished: true,
  },
  {
    sousId: 18,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.xargo,
    contractAddress: {
      25: '0xae77Df2E2821849d0343abdF5631b5C35D787811',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '4.15440699935191186',
    sortOrder: 1,
    isFinished: true,
  },
  {
    sousId: 17,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.single,
    contractAddress: {
      25: '0x1AACc5C227f3603Dc7796f8dc28Ab236f751735B',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '3.993303089220133938',
    sortOrder: 1,
    isFinished: false,
    suffix: 'ep.3',
  },
  {
    sousId: 16,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.ferro,
    contractAddress: {
      25: '0x87fD1bDeE5dd3F93Ec78adf1743eB804D796aA79',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '11.572608796296296296',
    sortOrder: 1,
    isFinished: true,
  },
  {
    sousId: 15,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.ferro,
    contractAddress: {
      25: '0xE3D0B112DF42B525501d9312f81d80dFF21f89c8',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '11.574074074074074074',
    sortOrder: 1,
    isFinished: true,
  },
  {
    sousId: 14,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.single,
    contractAddress: {
      25: '0x7bc5d594531759F8989Eb1a0f8302174cE0503b4',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '4.541666666666666666',
    sortOrder: 1,
    isFinished: false,
    suffix: 'ep.2',
  },
  {
    sousId: 13,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.argo,
    contractAddress: {
      25: '0xC89BF1EEEF0ba6417485DfA6B7B732113155Fc96',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '3.472222222222222222',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 12,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.sky,
    contractAddress: {
      25: '0x0b8D4cC66fecEE7CBF687B438Bcc97fa40716ecb',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.000112268287037037',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 11,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.dark,
    contractAddress: {
      25: '0xf7514c62582937ed661AC008d2EaEfECA12DAf16',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.555553240740740741',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 10,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.single,
    contractAddress: {
      25: '0xa618D96d36Cb32a7618e71850BD569726608372E',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '5.787037037037037037',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 9,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.versa,
    contractAddress: {
      25: '0x2D676d626D812A38Eee2AddBF8b22416c0313EFb',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '1.730324074074074074',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 7,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.ness,
    contractAddress: {
      25: '0xA3b4d4A5b287e8ec105F49246C642faCE481df55',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.185185185185185185',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 8,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.vshare,
    contractAddress: {
      25: '0xC01d557a3a0408De13d0A204cDB30277De1c8255',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.028819444444444444',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 5,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.tusd,
    contractAddress: {
      25: '0xCf50995E41d3CdA83E0997B5dAAEB2bd73300BF2',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.11174496644295302',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 4,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.single,
    contractAddress: {
      25: '0xe94D70F670d82b250f477D461059201570531CE3',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '4.62962962962962963',
    sortOrder: 1,
    isFinished: false,
    suffix: 'ep.1',
  },
  {
    sousId: 3,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.tonic,
    contractAddress: {
      25: '0xA46c0382654248509A1Ed888ccCBa964693DedcB',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '3472222.222222222222222222',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 1,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.bifi,
    contractAddress: {
      25: '0xF0b9B4FbD1d6b6b9B9fa13736Fe12bd2414bc677',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.00007777777778',
    sortOrder: 1,
    isFinished: true,
  },
  {
    sousId: 2,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.bifi,
    contractAddress: {
      25: '0x1a888D7b2abFD2B5046D8461e6D1703F654a8fc0',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.00007777777778',
    sortOrder: 1,
    isFinished: false,
  },
  {
    sousId: 6,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.single,
    contractAddress: {
      25: '0xA9E36deeE3b457Ae50CD1776F205C1D389e6D16B',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '4.475251734168717834',
    sortOrder: 1,
    isFinished: false,
    suffix: 'ep.2',
  },
  {
    sousId: 23,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.vno,
    contractAddress: {
      338: '',
      25: '0x315c7A2AD01db46740E15126ff05Eac6A451E62E',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    sortOrder: 999,
    tokenPerBlock: '0.3858024691',
    isFinished: false,
  },
  {
    sousId: 24,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.ful,
    contractAddress: {
      338: '',
      25: '0x311FaCC800eA658a2754dc3F6364843c4f7dBb92',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    sortOrder: 999,
    tokenPerBlock: '2.88066139985740726',
    isFinished: false,
  },
  {
    sousId: 25,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.vno,
    contractAddress: {
      338: '',
      25: '0x743737370644cEb6eA6867d1fDE6e5157ac6a679',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    sortOrder: 999,
    tokenPerBlock: '0.1467526756',
    isFinished: false,
    suffix: 'ep.2',
  },
  {
    sousId: 26,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.ferro,
    contractAddress: {
      25: '0x3a4e2F91f80f8Bb149D78659F7858c1fe6f1cad3',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.375725915171',
    sortOrder: 1,
    isFinished: false,
    suffix: 'ep.2',
  },
  {
    sousId: 27,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.mtd,
    contractAddress: {
      25: '0xa75D26750B71046C43aA6a9EEf1294D48967D28B',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.037908794206',
    sortOrder: 1,
    isFinished: false,
    suffix: 'ep.3',
  },
  {
    sousId: 28,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.croid,
    contractAddress: {
      25: '0xFbc4cd02E3E2DF6Bd2E22FCE9f87118493531635',
      338: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.127218794289',
    sortOrder: 1,
    isFinished: false,
    suffix: 'ep.2',
  },
]

const testnetPools: SerializedPoolConfig[] = [
  {
    sousId: 0,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.vvs,
    contractAddress: {
      25: process.env.REACT_APP_CRAFTSMAN_ADDRESS_MAINNET,
      338: process.env.REACT_APP_CRAFTSMAN_ADDRESS_TESTNET,
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: (
      parseFloat(process.env.REACT_APP_VVS_PER_BLOCK) *
      (parseFloat(process.env.REACT_APP_CRAFTSMAN_POOL_ZERO_ALLOC_PT) /
        parseFloat(process.env.REACT_APP_CRAFTSMAN_TOTAL_ALLOC_PT))
    ).toString(),
    sortOrder: 1,
    isFinished: false,
  },
  // {
  //   sousId: 1,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.coffee,
  //   contractAddress: {
  //     338: '0x39550a42f29b618a2BcFC4e090a132c33Fa72C99',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '1',
  //   isFinished: true,
  // },
  // {
  //   sousId: 2,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.fish_ball,
  //   contractAddress: {
  //     338: '0x1335169703e3A6C14f5B259a978365355D409e6C',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '2',
  //   isFinished: true,
  // },
  // {
  //   sousId: 3,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.rich_man,
  //   contractAddress: {
  //     338: '0xEe2816c84ca7f56407152Bed442D9b1466dcdbeE',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '200',
  //   isFinished: true,
  // },
  // {
  //   sousId: 4,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.poor_man,
  //   contractAddress: {
  //     338: '0x332146Cd632b1b2da5615bF445fe6A1fc1fB9eeA',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '10',
  //   isFinished: true,
  // },
  // {
  //   sousId: 5,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.banana,
  //   contractAddress: {
  //     338: '0x56B351C62bAC0FFdAaDBf92a700742F3554a4A46',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '1000',
  //   isFinished: true,
  // },
  // {
  //   sousId: 6,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.orange,
  //   contractAddress: {
  //     338: '0x47471C18D96A4eEd3004571Ffe246D4e02352E5d',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '1000',
  //   isFinished: true,
  // },
  // {
  //   sousId: 7,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.salad,
  //   contractAddress: {
  //     338: '0xaa2ada29f78E24870468043Aa813FdCCF91d45C3',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '1000',
  //   isFinished: true,
  // },
  // {
  //   sousId: 8,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.pizza,
  //   contractAddress: {
  //     338: '0x97Bb482b7321dA760C10A459605AB829505C5314',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '1000',
  //   isFinished: true,
  // },
  // {
  //   sousId: 9,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.pizza,
  //   contractAddress: {
  //     338: '0xB1B7c908617ee3567A3c58710f25E4b3F4AFBA50',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '0.00007564755064',
  //   isFinished: true,
  // },
  // {
  //   sousId: 10,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.pizza,
  //   contractAddress: {
  //     338: '0x79FDD3B7251eAbB82492eBcfd118B57697b634E0',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '0.00007564755064',
  //   isFinished: false,
  // },
  // {
  //   sousId: 11,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.pizza,
  //   contractAddress: {
  //     338: '0xc970287636bDBf522B110a635F9259cDa83722FE',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '0.00007777777778',
  //   isFinished: false,
  // },
  // {
  //   sousId: 12,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.ginger,
  //   contractAddress: {
  //     338: '0x8084c709d16C7191f16835BCA3f254Be456029cB',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '3472222.222222222222222222',
  //   isFinished: false,
  // },
  // {
  //   sousId: 13,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.pizza,
  //   contractAddress: {
  //     338: '0x6B86012cBDCD0Abf4Bd5d794891A1fd9f4Dd2F27',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '0.00007777777778',
  //   isFinished: true,
  // },
  // {
  //   sousId: 14,
  //   stakingToken: serializedTokens.vvs,
  //   earningToken: serializedTokens.muffin,
  //   contractAddress: {
  //     338: '0x09c39E75AF6E80D073142F93EE14C6fC6fcF2A99',
  //     25: '',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   sortOrder: 999,
  //   tokenPerBlock: '1543209.876543209876543209',
  //   isFinished: false,
  // },
  {
    sousId: 15,
    stakingToken: serializedTokens.vvs,
    earningToken: serializedTokens.pizza,
    contractAddress: {
      338: '0x6a831bE9D73DEaF7201Da27a623e11357bd9F78a',
      25: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    sortOrder: 999,
    tokenPerBlock: '4.62962962962962963',
    isFinished: false,
  },
  {
    sousId: 16,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.pizza,
    contractAddress: {
      338: '0x2ae4108E07ecb5fDeCeBf5C2B1D64D6f72173133',
      25: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    sortOrder: 999,
    tokenPerBlock: '0.040972222222222222',
    isFinished: false,
  },
  {
    sousId: 17,
    stakingToken: serializedTokens.xvvs,
    earningToken: serializedTokens.pizza,
    contractAddress: {
      338: '0x9731F400843Ab727047E15723D0f1d2F89BE3ED4',
      25: '',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    sortOrder: 999,
    tokenPerBlock: '0.196064814814814815',
    isFinished: false,
  },
]

const pools: SerializedPoolConfig[] =
  process.env.REACT_APP_CHAIN_ID === ChainId.MAINNET.toString() ? mainnetPools : testnetPools

export default pools
